import script from "./EpkChapter.vue?vue&type=script&setup=true&lang=js"
export * from "./EpkChapter.vue?vue&type=script&setup=true&lang=js"

import "./EpkChapter.vue?vue&type=style&index=0&id=9117d186&lang=scss"

const __exports__ = script;

export default __exports__